import React from 'react'

const Icon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
		<path
			className="fill-current"
			d="M2.887 15.028l4.083-4.083 3.393 3.395 3.789-3.788L12 8.4h6v6l-2.152-2.152-5.485 5.486L6.97 14.34 4 17.309a9.6 9.6 0 10-1.113-2.28v-.001zm-1.845 1.87l-.012-.013.004-.005A11.958 11.958 0 010 12C0 5.372 5.372 0 12 0s12 5.372 12 12-5.372 12-12 12c-4.884 0-9.084-2.916-10.958-7.103z"
		/>
	</svg>
)

export default Icon
